import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, Select } from 'antd';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
const FormItem = Form.Item;
const Option = Select.Option;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { getPropsFromItem } from './SgiCompComm';
// const store = [];
// for (let i = 10; i < 36; i++) {
//     store.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
// }

class SgiFormSelect extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
        this.state.store = []; //下拉框内容
        this.state.showValue = undefined; //展示的值
        this.state.placeholder = this.props.moduleDesc.inpPopTe; //提示信息
        this.state.emptyText = this.props.moduleDesc.emptyText; //下拉数组为空提示信息
        this.state.scList = [];
        this.state.allScList = [];
        this.state.shows = null; //下拉窗显示项，不为空则表示启用，只能显示指定项

        // 订阅标准代码更新
        let scId = (this.props.moduleDesc || {}).scId;
        if (scId) this.state.unsubscribe_sc = StandardCode.subscribe(scId, (newSCList) => {
            if (!newSCList) return;
            this.fitStore(newSCList);
            this.setState({});
        });
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    select_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //组装下拉框内容
        this.fitSelectOption(moduleDesc);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
    }

    /**
     * 组装下拉框内容
     * @param {描述} moduleDesc
     */
    fitSelectOption(moduleDesc) {

        this.state.store = [];

        // 下拉窗列表值在标准代码中的id
        var comboBoxData = StandardCode.getSC(moduleDesc.scId);
        if (!comboBoxData) {
            return;
        }
        this.fitStore(comboBoxData);
    }


    /**
     * 组装下拉框内容
     * @param {描述} moduleDesc
     */
    fitStore(comboBoxData, attKey, attName) {

        if (!attKey) attKey = 'c';
        if (!attName) attName = 'te';

        this.state.store = [];

        let allScList = [];
        let scList = [];
        var size = comboBoxData.length;
        if (!size == 0) {
            for (let i = 0; i < size; i++) {
                var item = comboBoxData[i];
                allScList.push({ te: (item[attName]), c: (item[attKey]), itemData: item, ...getPropsFromItem(item) });
            }
            this.state.allScList = allScList;

            // 控制显示项
            scList = allScList;
            if (this.state.shows && this.state.shows.length > 0) {
                scList = allScList.filter(sc => (this.state.shows.indexOf(sc.c) > -1));
            }
            this.state.scList = scList;

            // 限制数量
            // if (this.state.numLimit && scList.length > this.state.numLimit) {
            //     scList = scList.slice(0, this.state.numLimit);
            // }

            scList.forEach((item, index) => {
                let pitem = { ...item };
                delete pitem.c;
                delete pitem.te;
                this.state.store.push(<Option value={item.c} {...pitem}>{item.te}</Option>);
            })
        }
    }

    dynamicRefreshCombox(comboBoxData, attKey, attName) {
        if (!comboBoxData) return;

        this.fitStore(comboBoxData, attKey, attName);
        this.setState({ loading: false });
    }

    setDisabledItems(disabledList, attKey) {
        disabledList = disabledList || [];
        attKey = attKey || 'c';

        let scList = this.state.scList;
        this.state.store = [];

        scList.forEach((item, index) => {
            let disabled = false;
            for (const disItem of disabledList) {
                if (item.c === disItem[attKey]) {
                    disabled = true;
                    break;
                }
            }
            this.state.store.push(<Option disabled={disabled} value={item.c} {...item}>{item.te}</Option>);
        })
        this.setState({ loading: false });
    }

    getShowValue() {

        var comboBoxData = this.state.allScList || StandardCode.getSC(this.props.moduleDesc.scId) || [];

        let value = this.state.inputprops.value;
        var newcomboBoxData = [];
        if (value && !(value instanceof Array)) {
            var valueList = value.split(",");//拆分
            for (var i = 0; i < valueList.length; i++) {
                var uceC = valueList[i];
                newcomboBoxData.push(uceC);
            }
        } else if (value) {
            newcomboBoxData = value;
        }

        let showValue = [];

        for (let j = 0; j < newcomboBoxData.length; j++) {
            for (let i = 0; i < comboBoxData.length; i++) {
                var item = comboBoxData[i];
                if (newcomboBoxData[j] == item["c"]) {
                    showValue.push(item["te"]);
                    break;
                } else if (i === comboBoxData.length - 1) {
                    // 最后一个仍然不匹配
                    showValue.push(newcomboBoxData[j]);
                }
            }
        }

        return showValue.join(",");
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops) {
        //csstyle 样式文件?这个我还不知道怎么用
        // var csstyle = moduleDesc.csstyle;

        //多选
        var mulSel = moduleDesc.mulSel;
        if (mulSel) {
            inputprops.mode = "multiple";
            // inputprops.tokenSeparators = ",";
        }
        //mode为tags
        var tags = moduleDesc.tags;
        if (tags) {
            inputprops.mode = "tags";
        }
        //设置是否自动选择第一个列表值，默认是true
        var autoSel = moduleDesc.autoSel;
        if (autoSel && this.state.store.length > 0) {
            inputprops.defaultValue = this.state.store[0].key;
        }

        // 显示项
        let shows = moduleDesc.shows;
        if (shows && shows.length > 0) this.state.shows = shows;
        else this.state.shows = null;

        //当下拉列表为空时显示的内容
        // if (this.state.store.length < 1) {
        //     this.state.placeholder = moduleDesc.emptyText;
        // } else {
        //     this.state.placeholder = moduleDesc.inpPopTe;
        // }
        // 设置输入值是否严格为待选列表中的存在的值，默认值为false 未解决
        var forceSelection = moduleDesc.forceSelection;
        //不知道干嘛用的
        var anyMatch = moduleDesc.anyMatch;
        //delimiter : ",", // 多选数据分隔符
        //filterPickList : 'true',// 多选隐藏从下拉列表中的当前选定的值
        //selType: 'checkboxmodel', //多选样式
        //valueField : "c", // 组合框的值字段

        //queryMode : 'local', // 本地模式

        //typeAhead : true  //不知道什么意思
        //是否使用搜索框
        var showSearch = moduleDesc.showSearch;
        inputprops.showSearch = showSearch;
        inputprops.optionFilterProp = 'children';
        // inputprops.allowClear = true; //支持清除
        inputprops.allowClear = moduleDesc.allowClear; //支持清除
        // if (showSearch) {
        //     inputprops.showSearch = 'showSearch';
        // }

        // 下拉项数量控制
        this.state.numLimit = moduleDesc.numLimit;
    }

    _onFocus = () => {
        this.state.searchVal = "";
        this.searchValue();
    }

    // onBlur = () => {
    // let data = this.state.allScList || StandardCode.getSC(this.props.moduleDesc.scId) || [];
    // this.state.store = [];
    // data.forEach((item, index) => {
    //     let pitem = { ...item };
    //     delete pitem.c;
    //     delete pitem.te;
    //     this.state.store.push(<Option value={item.c} {...pitem}>{item.te}</Option>);
    // })
    // this.setState({});
    // };

    onSearch = val => {
        if (!this.timer) {
            const that = this;
            this.timer = setTimeout(function () {
                that.searchValue();
                that.timer = null;
            }, 300);
        }
        this.setState({ searchVal: val });
    };
    searchValue = () => {
        let value = this.state.searchVal;
        // if (!value) return;
        let data = this.state.allScList || StandardCode.getSC(this.props.moduleDesc.scId) || [];
        // 筛选
        let data_ = data.filter(item => item.te && item.te.indexOf(value) > -1 && (this.state.shows && this.state.shows.length > 0 ? this.state.shows.indexOf(item.c) > -1 : true));
        // 数量限制
        if (this.state.numLimit && (data_.length > this.state.numLimit || value === "")) {
            data_ = data_.slice(0, this.state.numLimit);
        }
        this.state.store = [];
        data_.forEach((item, index) => {
            let pitem = { ...item };
            delete pitem.c;
            delete pitem.te;
            this.state.store.push(<Option value={item.c} {...pitem}>{item.te}</Option>);
        })
        this.setState({});
    };

    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.select_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        let value = this.state.inputprops.value;
        var newcomboBoxData = [];
        if (value && !(value instanceof Array)) {
            var valueList = value.split(",");//拆分
            for (var i = 0; i < valueList.length; i++) {
                var uceC = valueList[i];
                newcomboBoxData.push(uceC);
            }
            this.state.inputprops.value = newcomboBoxData;

        } else {
            this.state.inputprops.value = value;
        }

        let placeholder = this.state.placeholder;
        if (!this.state.store || this.state.store.length === 0) {
            placeholder = this.state.emptyText;
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let showValue = this.getShowValue();
        if (showValue === undefined) showValue = this.state.inputprops.value;

        // 多选时，null会展示空标签
        if (this.state.inputprops.value === null) this.state.inputprops.value = undefined;

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps} title={showValue}>{showValue}</span>
            : <Select  {...this.state.inputprops} {..._inputProps} placeholder={placeholder}
                onSearch={this.state.numLimit ? this.onSearch : undefined}
            // onFocus={this.onFocus}
            // onBlur={this.onBlur}
            >{this.state.store}</Select>;

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }

    componentWillUnmount() {
        // 取消标准代码订阅
        let unsubscribe = this.state.unsubscribe_sc;
        if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    }
}
//给类添加公共方法
Object.assign(SgiFormSelect.prototype, sgiFormCtlBaseFun);
export { SgiFormSelect };
export default SgiFormSelect;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormSelect.js